import { useState } from "react";

import { Outlet, useNavigate } from "react-router-dom";

import { AlertModal } from "shared/components/modal/AlertaModal";

import { useLoja } from "shared/contexts/Loja/LojaContext";

export const LojaGuard = () => {
  const navigate = useNavigate();

  const {
    loading,
    possuiLoja,
    kycValidado,
    podeCadastrarProdutos,
  } = useLoja();

  const [modalOpen, setModalOpen] = useState(true);

  if (loading) {
    return <p>Carregando...</p>;
  }

  if (podeCadastrarProdutos) {
    return <Outlet />;
  }

  return (
    <>
      <AlertModal
        open={modalOpen}
        type="warning"
        title="Validação necessária"
        description={
          !possuiLoja
            ? "Para cadastrar produtos é necessário cadastrar uma loja."
            : !kycValidado
            ? "Para cadastrar produtos é necessário validar sua conta."
            : "Sua loja ainda não está disponível para cadastro de produtos."
        }
        onClose={() => {
          setModalOpen(false);
          navigate("/minhaslojas", {
            replace: true,
          });
        }}
        onContinuar={() => {
          setModalOpen(false);

          if (!possuiLoja) {
            navigate("/cadastroloja", {
              replace: true,
            });
            return;
          }

          if (!kycValidado) {
            navigate("/minhaslojas", {
              replace: true,
            });
            return;
          }

          navigate("/minhaslojas", {
            replace: true,
          });
        }}
      />
    </>
  );
};